import Axios from 'api/client';
import { BASE_PROMPTS } from 'constants/tinyAiPlugin';

const sendAIRequest = (accountId: number, prompt: string, signal: AbortSignal) =>
    Axios.post(`/accounts/${accountId}/ai`, { prompt }, { signal }).then(response => response.data);

interface AiRequestHandlerRequest {
    query: string;
    context: string;
    prompt: string;
    thread: string[];
    system: string[];
}

type RespondWithHandlerCallback = (signal: AbortSignal) => Promise<string>;

interface AiRequestHandlerRespondWith {
    string: (callback: RespondWithHandlerCallback) => void;
    stream: (callback: RespondWithHandlerCallback) => void;
}

const aiRequestHandler =
    (accountId: number, basePrompts: string[] = BASE_PROMPTS) =>
    (request: AiRequestHandlerRequest, respondWith: AiRequestHandlerRespondWith) => {
        respondWith.string((signal: AbortSignal) =>
            sendAIRequest(accountId, `${basePrompts.join(' ')} ${request.prompt}`, signal)
                .then(async response => {
                    return response.choices[0]?.message?.content?.trim();
                })
                .catch(() => {
                    throw new Error('Sorry, looks like we’re having trouble. Try again later.');
                }),
        );
    };

export { sendAIRequest, aiRequestHandler };
